export const omitProps = (object, ...propNames) => {
  const omitted = { ...object };
  for (const propName of propNames) {
    delete omitted[propName];
  }
  return omitted;
};

export const convertCamelCaseKeys = (object) => {
  if (Object.prototype.toString.call(object) == '[object Array]') {
    return object.map((entity) => convertCamelCaseKeys(entity));
  }

  if (Object.prototype.toString.call(object) == '[object Object]') {
    return Object.keys(object).reduce((convertedObject, key) => {
      const camelCaseKey = key.replace(/_([a-z])/g, (match, letter) =>
        letter.toUpperCase()
      );
      convertedObject[camelCaseKey] = convertCamelCaseKeys(object[key]);
      return convertedObject;
    }, {});
  }

  return object;
};
